
import React from 'react'

import Menu2 from './Menu/Menu2'
import { ConfirmDialog } from 'primereact/confirmdialog'

function Header2() {
  return (
    <div className='flex justify-content-start align-content-center  ' 
        style={{height:'70px', fontSize:'30px' , justifyContent :'center' }}>

        <Menu2></Menu2>

        <a className='layout-topbar-logo align-content-center' >
          <span>Digital Shop ( Bot Prepago ) </span>
        </a>

        

    </div>
  )
}

export default Header2